import { colors } from '../../Colors/colors'

export const portalsAuthTheme = {
   light: {
      login: {
         reservedName: 'text-gray-600',
         loginWithPhoneNumber: {
            loginTextColor: 'text-gray-900',
            loginDescriptionTextColor: 'text-gray-600'
         },
         common: {
            loginBGColor: 'bg-white',
            footerDetailsTextColor: 'text-gray-600'
         },
         otp: {
            otpVerificationStep: {
               emailAndNumberTextColor: 'text-gray-600',
               otpDescriptionTextColor: 'text-gray-600',
               otpTextColor: 'text-gray-900',
               errorTextColor: 'text-error-500',
               backArrowIconColor: colors['gray-600']
            },
            otpWithResendField: {
               otpTimerTextColor: 'text-gray-600',
               disabledOtpTimerTextColor: 'text-gray-300',
               resendButtonBGColor: 'bg-transparent',
               resendOTPActiveTextColor: 'text-blue-600',
               resendOTPDisabledTextColor: 'text-gray-300'
            },
            sixBoxesInputField: {
               labelTextColor: 'text-gray-700',
               errorTextColor: 'text-red-600'
            }
         },
         otpInputs: {
            otpInputDisabledBorderColor: 'border-gray-300',
            otpInputEnabledBorderColor: 'border-primary-600',
            otpInputBGColor: 'bg-white',
            otpInputTextColor: 'text-primary-600',
            otpInputFocusBGColor: 'bg-white',
            otpInputFocusBorderColor: 'focus:border-primary-600',
            otpInputErrorBorderColor: '!border-error-300',
            otpErrorInputTextColor: '!text-error-700'
         }
      },
      logout: {
         alertIconColor: colors['warning-600'],
         alertOuterIconBgColor: colors['warning-50'],
         alertInnerIconBgColor: colors['warning-100']
      },
      sessionLogoutModal: {
         infoIconColor: colors['gray-500'],
         infoOuterBgColor: colors['primary-50'],
         infoInnerBgColor: colors['primary-100'],
         backgroundColor: 'bg-base-white',
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500']
      },
      accessDeniedView: {
         alertContainerBorderColor: 'border-error-300',
         alertContainerBGColor: 'bg-error-25',
         alertHeaderTextColor: 'text-error-700',
         alertDescriptionTextColor: 'text-error-700',
         accessDeniedBorderColor: 'border-gray-300'
      },
      otpSuccessView: {}
   },

   dark: {}
}
